import { EGoogleTagEvents } from 'common/const/google-tag-manager.const';

export const googleTagManagerPushEvent = (event: EGoogleTagEvents) => {
  window?.dataLayer.push({ event });
};
